import { useEffect } from "react";

function useRevealOnIntersect(selector, options = {}, refreshKey = null) {
  const { root = null, rootMargin = "0px", threshold = 0 } = options;

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(selector));
    if (elements.length === 0) {
      return undefined;
    }

    if (!("IntersectionObserver" in window)) {
      elements.forEach((element) => element.classList.add("in"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            observer.unobserve(entry.target);
          }
        });
      },
      { root, rootMargin, threshold }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [selector, root, rootMargin, threshold, refreshKey]);
}

export default useRevealOnIntersect;